// The name predates the in-house runtime (it was gt-next's); keeping it
// preserves every visitor's saved language choice.
export const LOCALE_COOKIE_NAME = "generaltranslation.locale";

export function persistServerLocale(locale: string) {
  if (typeof document === "undefined") return;
  document.cookie = `${LOCALE_COOKIE_NAME}=${encodeURIComponent(locale)};path=/`;
}
